import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ApplicationEnquiryForm from "../../components/forms/ApplicationEnquiryForm.js";
import { fetchStudentData } from "../../store/PersonalBasicInfoSlice.js";
import { fetchStaffData } from "../../store/StaffBasicInfoSlice.js";

import { updateFormField } from "../../store/ApplicationEnquirySlice.js";
import { setWhoIsTheUser } from "../../store/WhoIsTheUserSlice.js";
const ApplicationEnquiryNewParent = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const parentDetails = useSelector((state) => state.studentdata.parentDetails);
  const { staffDetails } = useSelector((state) => state.staffData);
  const { isStaff, isParent, isStudent } = useSelector(
    (state) => state.whoIsTheUser,
  );

  const [mobilePhone, setMobilePhone] = useState("");
  const [email, setEmail] = useState("");
  const [idCopyFile, setIdCopyFile] = useState("");

  useEffect(() => {
    if (isAuthenticated) {
      const userInfoString = localStorage.getItem("userInfo");
      const userInfo = userInfoString ? JSON.parse(userInfoString) : {}; // Parse if
      const roles = userInfo?.roles || [];
      dispatch(setWhoIsTheUser({ isAuthenticated, roles }));

      dispatch(fetchStudentData()); // Fetch student and parent data if authenticated
      dispatch(fetchStaffData()); // Fetch staff data if authenticated
    }
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    if (isAuthenticated) {
      console.log("isAuthenticated", isAuthenticated);
      if (parentDetails.length > 0) {
        const firstParent = parentDetails[0];
        console.log("firstParent", firstParent);
        setMobilePhone(firstParent.mobilePhone);
        setEmail(firstParent.email);
        setIdCopyFile(firstParent.idCopyFile);
      } else if (Object.keys(staffDetails).length) {
        console.log("staffDetails", staffDetails);
        setMobilePhone(staffDetails.phoneNumber);
        setEmail(staffDetails.email);
        setIdCopyFile(staffDetails.idCopyFile);
      }
      dispatch(
        updateFormField({
          name: "PhoneNumber",
          value: mobilePhone,
        }),
      );
      dispatch(
        updateFormField({
          name: "ContactEmail",
          value: email,
        }),
      );
      dispatch(
        updateFormField({
          name: "IncomeType",
          value: "2",
        }),
      );
      dispatch(
        updateFormField({
          name: "IncomeLevel",
          value: "2",
        }),
      );
    }
  }, [
    dispatch,
    email,
    isAuthenticated,
    mobilePhone,
    parentDetails,
    staffDetails,
  ]);

  return (
    <>
      {!isStudent && (
        <ApplicationEnquiryForm isStaff={isStaff} isParent={isParent} />
      )}
    </>
  );
};

export default ApplicationEnquiryNewParent;
